import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';
import { init } from "./i18n";
import { URL } from "../const";
function getPackUrl(_ref) {
  var packId = _ref.packId,
    packVersion = _ref.packVersion,
    _ref$env = _ref.env,
    env = _ref$env === void 0 ? 'pre' : _ref$env;
  return (env === 'pre' ? URL['pack-daily'] : URL['pack-prod']) + "/upload/pack/" + packId + (packVersion ? '/' + packVersion : '') + "/lang.js";
}
export var getPackLocale = function getPackLocale(_ref2) {
  var packId = _ref2.packId,
    packVersion = _ref2.packVersion,
    _ref2$env = _ref2.env,
    env = _ref2$env === void 0 ? 'pre' : _ref2$env;
  return fetch(getPackUrl({
    packId: packId,
    packVersion: packVersion,
    env: env
  })).then(function (res) {
    return res.text();
  }, function () {
    return '';
  }).then(function (cdnLocale) {
    if (!cdnLocale) {
      return null;
    }
    var matchs = cdnLocale.includes('const exui') ? cdnLocale.match(/const\scontent\s=\s(.+);const\sexui/) : cdnLocale.match(/const\scontent\s=\s(.+);if\s?\(window\._PANDA_I18N\)/);
    if (!matchs) {
      return null;
    }
    var langDataMap = mapKeys(JSON.parse(matchs[1]), function (v, key) {
      return key.replace('_', '-');
    });
    var parsedLocale = mapValues(langDataMap, function (item) {
      return item ? mapValues(item.copyList, function (_copy) {
        return _copy.content;
      }) : {};
    });
    return parsedLocale;
  });
};
export var getPackI18n = function getPackI18n(_ref3) {
  var packId = _ref3.packId,
    packVersion = _ref3.packVersion,
    _ref3$env = _ref3.env,
    env = _ref3$env === void 0 ? 'pre' : _ref3$env;
  return getPackLocale({
    packId: packId,
    packVersion: packVersion,
    env: env
  }).then(function (parsedLocale) {
    return parsedLocale ? init({
      locale: parsedLocale
    }) : null;
  });
};